import './traducciones_lang';

const translatedMessagesExport = translatedMessages;

export default translatedMessagesExport;
